module.exports = __webpack_public_path__ + "static/media/delivery-disabled.a241ca5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/delivery-disabled.svg
// module id = 2252
// module chunks = 0